import { z } from 'zod';
import type { EntitlementRule } from '@/api/auth/missionImpactAuthAPI.schemas';
import { BILLING_SCENARIOS } from '@/lib/billing-scenarios';

/**
 * Schema for creating a Stripe price mapping
 */
export const createStripePriceSchema = z.object({
  stripePriceId: z
    .string()
    .min(1, 'Stripe Price ID is required')
    .regex(/^price_/, 'Stripe Price ID must start with "price_"'),
  stripeProductId: z
    .string()
    .min(1, 'Stripe Product ID is required')
    .regex(/^prod_/, 'Stripe Product ID must start with "prod_"'),
  entitlementRule: z.custom<EntitlementRule>(),
  basePriceId: z.string().optional(),
  scenario: z.enum(BILLING_SCENARIOS).nullable().optional(),
  isTierDefault: z.boolean(),
  adjustableQuantity: z.boolean(),
  minQuantity: z.number().int().min(0),
  maxQuantity: z.number().int().min(1).nullable().optional(),
});

/**
 * Schema for updating a Stripe price mapping
 */
export const updateStripePriceSchema = z.object({
  entitlementRule: z.custom<EntitlementRule>(),
  scenario: z.enum(BILLING_SCENARIOS).nullable().optional(),
  isTierDefault: z.boolean(),
  adjustableQuantity: z.boolean(),
  minQuantity: z.number().int().min(0),
  maxQuantity: z.number().int().min(1).nullable().optional(),
});

/**
 * TypeScript types inferred from schemas
 */
export type CreateStripePrice = z.infer<typeof createStripePriceSchema>;
export type UpdateStripePrice = z.infer<typeof updateStripePriceSchema>;
